/**
 * News/Journal/Stories Page
 */
const PageNews = ($) => {

	if ($('body').hasClass('blog')) {

		var ajaxurl = mainScript.ajaxurl; // eslint-disable-line
		var responseArea = $('#news-results-area');
		var nonce = $('.slc_loadmore').data('nonce');
		var lang = $('.slc_loadmore').data('lang');

		$('.slc_loadmore').click(function () {

			var lastPage = $('.slc_loadmore').data('last'); // True or false
			var currentPage = $('.slc_loadmore').data('page');

			if (lastPage == true) {
				$('.slc_loadmore').remove(); // Remove "load More" button if last page
			} else {
				loadMore(currentPage); // Load more if not last page
			}

		});

		var loadMore = (currentPage) => {

			var buttonData = {
				'action': 'loadmore_news',
				'loadmore_news': nonce,
				'current_page': currentPage,
				'lang': lang,
			};

			$.ajax({
				type: "POST",
				dataType: "json",
				url: ajaxurl,
				data: buttonData,
				success: function (response) {
					responseArea.append(response.data.html);
					$('.slc_loadmore').data('page', currentPage + 1);
					if (response.data.lastPage) {
						$('.slc_loadmore').remove();
						$('.slc_loadmore').data('last', true);
					}
				},
				error: function () {
					console.log('LOAD MORE ERROR');
				},
			});
		};

		$(document).ready( function () {
			loadMore(1); // Load first page on page load
		});
	}
};

export default PageNews;
